export type Brand<T, B extends string> = T & { readonly __brand: B };

export type DeviceId = Brand<string, "DeviceId">;
export type TerminalId = Brand<string, "TerminalId">;
export type ConductorId = Brand<string, "ConductorId">;
export type CircuitId = Brand<string, "CircuitId">;
export type CableId = Brand<string, "CableId">;
export type SheetId = Brand<string, "SheetId">;
export type ReferenceId = Brand<string, "ReferenceId">;

export const deviceId = (s: string) => s as DeviceId;
export const terminalId = (s: string) => s as TerminalId;
export const conductorId = (s: string) => s as ConductorId;
export const circuitId = (s: string) => s as CircuitId;
export const cableId = (s: string) => s as CableId;
export const sheetId = (s: string) => s as SheetId;
export const referenceId = (s: string) => s as ReferenceId;

export const newId = (prefix: string): string => {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${prefix}_${hex}`;
};
